import React from "react"
import {useSelector} from "react-redux";
import MovingPart from "./MovingPart";


const MovingParts = () => {
  const movingPartsList = useSelector(state => state.toggle.movingPartsList);

  return (
    <div className={"moving-parts"}>
      <ul>
        {movingPartsList && movingPartsList.map((item) => (
          <MovingPart key={item.title} movingPart={item}/>
        ))}
      </ul>
    </div>
  )
}

export default MovingParts;
